import { vb } from '@tencent/vbproxy-grpc/proto/ao_vb_loan_approval_server'

export interface IVoucherInfo {
    voucherFormat: string          // 证明格式, "pic"-图片,"pdf"-pdf文件
    voucherUrl: string             // 证明cos url
}

export enum ProofVoucherType {
    ADDRESS = 1,               // 地址证明
    INCOME = 2,                // 收入证明
    WORK_VISA = 3,              // 工作签证
    PASS = 4,                   // 通行证
}

export enum ProofType {
    ADDRESS = 1,                        // 地址证明
    INCOME = 2,                        // 收入证明
    NON_PERMANENT = 3,                   // 非永居身份证明
}

export interface IProofItem {
    voucherType: ProofVoucherType // 1: 地址证明， 2: 收入证明 3: 工作签证 4: 通行证
    voucherInfos: IVoucherInfo[] // 材料
}

export interface IProofSaveReq {
    type: string // 业务类型， 目前是贷款 type=loan
    proofs: IProofItem[] // 需要添加的证明
    submitParame: string // json string其他参数，{time: 贷款时间， busId： 单号, scene: 1 贷前审批未通过， 2: 贷前提额, uploadType: 1 uploadFlag: 0}
}


export interface IDimProofRes {
    uploadInfo: vb.loan.ao.approval.IUserDimProofUploadInfo[]
}


export interface ICheckProofReuseReq {
    seqNo: string
    prodNo: string
}
